/**
 * Pathname
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { selectLocationPathname } from '../../../../../../workspaces/react-router-selectors';

interface Props {
    onChange: Function;
    pathname: string;
}

export class Pathname extends React.PureComponent<Props> {
    componentDidUpdate(prevProps: Props) {
        if (this.props.pathname !== prevProps.pathname) {
            this.props.onChange();
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    pathname: selectLocationPathname
});

export default connect(mapStateToProps)(Pathname);
